<sh-vertical-nav
    #nav
    background="surface"
    [overflow]="false"
    [attr.collapser]="showCollapser() ? 'bottom' : null"
    [attr.collapsed]="collapsed() ? true : null"
    [attr.active-index]="activeIndex()"
    (collapsed-changed)="onCollapsedChanged($event)"
    class="w-full min-w-0 max-w-none bg-shui-base-2"
>
    <sh-vertical-nav-item icon="home" routerLink="/" label="Home"></sh-vertical-nav-item>
    <sh-divider></sh-divider>
    @if (!collapsed()) {
        <span class="block px-2 text-xs font-semibold text-shui-text-subtle">{{
            'common.tasks.requests' | translate
        }}</span>
    }
    @for (item of requestItems(); track item.testId) {
        <sh-vertical-nav-item
            routerLink="/requests"
            [queryParams]="{ tab: item.tab }"
            [icon]="item.icon"
            [label]="item.label | translate"
            [attr.data-testid]="item.testId"
        ></sh-vertical-nav-item>
    }
    @if (subtaskItems().length > 0) {
        <sh-divider></sh-divider>
        @if (!collapsed()) {
            <span class="block px-2 text-xs font-semibold text-shui-text-subtle">{{
                'common.tasks.subtasks' | translate
            }}</span>
        }
        @for (item of subtaskItems(); track item.testId) {
            <sh-vertical-nav-item
                routerLink="/requests"
                [queryParams]="{ tab: item.tab }"
                [icon]="item.icon"
                [label]="item.label | translate"
                [attr.data-testid]="item.testId"
            ></sh-vertical-nav-item>
        }
    }
    <sh-divider></sh-divider>
    <sh-vertical-nav-item icon="plus" routerLink="/request" label="Create Request"></sh-vertical-nav-item>
    @if (features.isActive(EmeaFeature.PURCHASE_ORDER)) {
        <sh-vertical-nav-item
            icon="open-tasks-add"
            routerLink="/request"
            [queryParams]="{ type: 'PURCHASE_ORDER' }"
            label="Submit a Purchase Order"
        ></sh-vertical-nav-item>
    }
    @if (canAccessAdminArea()) {
        <sh-vertical-nav-item icon="access-control" routerLink="/admin" label="Admin Area"></sh-vertical-nav-item>
    }
    @if (showCountryIndicator()) {
        <div
            slot="collapser"
            keep-on-collapse
            id="emea-sidebar-country-indicator"
            role="button"
            tabindex="0"
            aria-haspopup="menu"
            class="w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer hover:bg-black/5 dark:hover:bg-white/10"
            data-testid="emea-sidebar-country-indicator"
            animate.enter="country-indicator-enter"
        >
            @if (selectedCountry(); as country) {
                <img
                    class="w-6 h-6 rounded-full object-cover"
                    src="/assets/images/flags/{{ country.toLowerCase() }}.svg"
                    [alt]="countryLabelKey() | translate"
                />
            } @else {
                <sh-icon
                    icon="globe"
                    size="s"
                    class="text-shui-text-subtle"
                    [attr.aria-label]="countryLabelKey() | translate"
                ></sh-icon>
            }
        </div>
    }
</sh-vertical-nav>
@if (showCountryIndicator()) {
    <sh-popover target="emea-sidebar-country-indicator" position="right-up" data-testid="emea-sidebar-country-popover">
        <sh-menu-item
            [toggle]="false"
            [label]="'common.general.global' | translate"
            [attr.active]="selectedCountry() === null ? true : null"
            data-testid="emea-sidebar-country-option-all"
            (click)="selectCountry(null)"
        >
            <sh-icon slot="functions" icon="globe" size="s" class="text-shui-text-subtle"></sh-icon>
        </sh-menu-item>
        @for (country of countries(); track country) {
            <sh-menu-item
                [toggle]="false"
                [label]="'countries.' + country.toLowerCase() | translate"
                [attr.active]="selectedCountry() === country ? true : null"
                [attr.data-testid]="'emea-sidebar-country-option-' + country.toLowerCase()"
                (click)="selectCountry(country)"
            >
                <img
                    slot="functions"
                    class="w-5 h-5 rounded-full object-cover"
                    src="/assets/images/flags/{{ country.toLowerCase() }}.svg"
                    alt="{{ country }} Flag"
                />
            </sh-menu-item>
        }
    </sh-popover>
}
